var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.isVisible
      ? _c("div", { staticClass: "popup-modal" }, [
          _c("div", { staticClass: "window" }, [_vm._t("default")], 2)
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }